// Team types
export const TEAM_MEMBERS_LOADED = 'TEAM_MEMBERS_LOADED';

// Service types
export const SERVICES_LOADED = 'SERVICES_LOADED';
export const ADDONS_LOADED = 'ADDONS_LOADED';
export const WAXES_LOADED = 'WAXES_LOADED'; 